// extracted by mini-css-extract-plugin
module.exports = {"box":"AlignmentBox_box__28tmS","content":"AlignmentBox_content__2fSVN","selectLabel":"AlignmentBox_selectLabel__1qEDa","inputWrapper":"AlignmentBox_inputWrapper__a-Zvo"};